import { useState } from 'react';
import Carousel from 'react-bootstrap/Carousel';
import { Link } from 'react-router-dom';

function ControlledCarousel() {
    const [index, setIndex] = useState(0);

    const handleSelect = (selectedIndex) => {
        setIndex(selectedIndex);
    };

    return (
        <Carousel activeIndex={index} onSelect={handleSelect}>
            <Carousel.Item>
                <Link to="/detail/14">
                    <img
                        className="d-block w-100"
                        src="/img/slide_1.jpg"
                        alt="First slide"
                    />
                    <Carousel.Caption>
                        <h6>TIPICOSI</h6>
                        <h2>SUMMER<br />LAUNCHING</h2>
                        <p>#티셔츠 #캔버스백 #에코백</p>
                    </Carousel.Caption>
                </Link>
            </Carousel.Item>

            <Carousel.Item>
                <Link to="/detail/108">
                    <img
                        className="d-block w-100"
                        src="/img/slide_2.jpg"
                        alt="Second slide"
                    />
                    <Carousel.Caption>
                        <h6>GOLF</h6>
                        <h2>CASUAL<br />OR CLASSY</h2>
                        <p>6월의 영골프 플레이어</p>
                    </Carousel.Caption>
                </Link>
            </Carousel.Item>

            <Carousel.Item>
                <Link to="/detail/98">
                    <img
                        className="d-block w-100"
                        src="/img/slide_3.jpg"
                        alt="Third slide"
                    />
                    <Carousel.Caption>
                        <h6>LUXURY</h6>
                        <h2>믿을 수 있는<br />LF몰 직수입명품</h2>
                        <p>럭셔리 클리어런스 세일</p>
                    </Carousel.Caption>
                </Link>
            </Carousel.Item>

            <Carousel.Item>
                <Link to="/detail/54">
                    <img
                        className="d-block w-100"
                        src="/img/slide_4.jpg"
                        alt="Second slide"
                    />

                    <Carousel.Caption>
                        <h6>KIDS</h6>
                        <h2>여행가기<br />좋은 날!</h2>
                        <p>키즈 여름 아이템 최대 할인</p>
                    </Carousel.Caption>
                </Link>
            </Carousel.Item>

            <Carousel.Item>
                <Link to="/detail/8">
                    <img
                        className="d-block w-100"
                        src="/img/slide_5.jpg"
                        alt="Second slide"
                    />

                    <Carousel.Caption>
                        <h6>질스튜어트 뉴욕 남성</h6>
                        <h2>서머<br />시즌오프</h2>
                        <p>여름 베스트 아이템 최대 할인</p>
                    </Carousel.Caption>
                </Link>
            </Carousel.Item>
        </Carousel>
    );
}

export default ControlledCarousel;